<script setup>
import { onMounted, ref, watch } from 'vue';
import { MultipleLookupConfig } from '@pfsc/core/models/multiple-lookup-config';

const props = defineProps({
  modelValue: {
    type: Array,
    required: true,
  },

  config: {
    type: MultipleLookupConfig,
    required: true,
  },

  disabled: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['update:model-value']);

const items = ref([]);
const selectedValues = ref([]);

/**
 * Handle values change.
 * @param {Array} values Values.
 */
function onValuesChange(values) {
  emits('update:model-value', values);
  selectedValues.value = values;
}

watch(() => props.modelValue, newVal => {
  selectedValues.value = newVal;
}, { deep: true });

onMounted(async () => {
  items.value = await props.config.fetch();
  selectedValues.value = props.modelValue;
});

</script>
<template>
  <div :class="$style.multipleLookup">
    <v-select
      :model-value="selectedValues"
      :items="items"
      chips
      multiple
      :clearable="props.config.clearable"
      :class="$style.select"
      :placeholder="props.config.title"
      density="compact"
      return-object
      :item-title="props.config.toReadable"
      hide-details
      :disabled="props.disabled"
      @update:model-value="onValuesChange"
    />
  </div>
</template>
<style module>
.multipleLookup {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.select {
  max-width: 500px;
}

.title {
  font-size: var(--font-size-md);
  display: flex;
  gap: 5px;
  align-items: flex-start;
}
</style>
